@if (isStars) {
    <div class="ng-hotel-stars">
        @for (star of stars; track $index) {
            @if (star) {
                <img [attr.src]="'/x-assets/img/icons/icon-y-star.svg'" alt=""/>
            }
        }
    </div>
} @else if (value?.length) {
    <div class="ng-default-value">
        {{ value }}
    </div>
}
